export default __webpack_public_path__ + "static/media/segretaroa-generale-sinodo.65a6ce5a.png";